import React from "react";
import "./Hero.css";
import teamx from "./teamx.jpg";
const Hero = () => {
  return (
    <div id="heroId">
      <img id="teamImage" src={teamx} alt="Team Image" />
      <span id="meetThe">
        Meet{" "}
        <img
          id="team-page-logo"
          src="../../../images/logos/teamX_Logo-02.png"
        />{" "}
      </span>
    </div>
  );
};

export default Hero;



// WEBPACK FOOTER //
// ./src/components/About/Hero/Hero.js